import React, { useState, useEffect } from 'react';
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import AccountsMenu from './AccountsMenu';
import { NavLink } from 'react-router-dom';
import YearsDropDown from '../Shared/YearsDropDown';
import Pagination from "../General/Pagination";
import moment from "moment";

function TrialBalanceHeadWise(props) {

    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [DefaultFYear, setDefaultFYear] = useState(localStorage.getItem("DefaultFYear"));
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [ClosingDebitTotal, setClosingDebitTotal] = useState("");
    const [ClosingCreditTotal, setClosingCreditTotal] = useState("");
    const [AccountLevel, setAccountLevel] = useState("0");
    const [EndDate, setEndDate] = useState("");
    const [showZeroAccounts, setShowZeroAccounts] = useState(true);
    const [showThirdOnly, setShowThirdOnly] = useState(false);

    const [appliedAccountLevel, setAppliedAccountLevel] = useState("0");
    const [appliedEndDate, setAppliedEndDate] = useState("");
    const [appliedShowZeroAccounts, setAppliedShowZeroAccounts] = useState(true);
    const [appliedShowThirdOnly, setAppliedShowThirdOnly] = useState(false);
    const [searchTrigger, setSearchTrigger] = useState(0);

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    document.title = 'Trial Balance Head Wise';

    const runSearch = () => {
        setAppliedAccountLevel(AccountLevel);
        setAppliedEndDate(EndDate);
        setAppliedShowZeroAccounts(showZeroAccounts);
        setAppliedShowThirdOnly(showThirdOnly);
        setPageNo(1);
        setSearchTrigger((prev) => prev + 1);
    };

    useEffect(() => {
        if (!DefaultFYear || !appliedEndDate) {
            setLoading(false);
            return;
        }
        const fyNum = parseInt(String(DefaultFYear).trim(), 10);
        if (!Number.isFinite(fyNum) || fyNum <= 0) {
            setLoading(false);
            return;
        }

        setLoading(true);
        axios({
            method: 'post',
            url: config.base_url + 'Accounts/GetTrialBalanceHeadWise',
            headers: { 'Content-Type': 'application/json' },
            data: {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                pageNo: pageNo,
                pageSize: pageSize,
                FYear: fyNum,
                EndDate: appliedEndDate,
                AccountLevel: parseInt(String(appliedAccountLevel), 10) || 0,
                ShowZeroAccounts: appliedShowZeroAccounts,
                ShowThirdOnly: appliedShowThirdOnly,
            },
        })
            .then(function (response) {
                if (response.data.status_code === 1 && Array.isArray(response.data.ListofRecords)) {
                    setLedger(response.data.ListofRecords);
                    setTotalRecords(response.data.totalRecords || 0);
                    setClosingDebitTotal(response.data.ClosingDebitTotal || "");
                    setClosingCreditTotal(response.data.ClosingCreditTotal || "");
                } else {
                    setLedger([]);
                    setTotalRecords(0);
                    setClosingDebitTotal("");
                    setClosingCreditTotal("");
                }
                setLoading(false);
            })
            .catch(function () {
                setLoading(false);
                setLedger([]);
                setTotalRecords(0);
            });
    }, [
        pageNo,
        pageSize,
        DefaultFYear,
        appliedAccountLevel,
        appliedEndDate,
        appliedShowZeroAccounts,
        appliedShowThirdOnly,
        searchTrigger,
        AccessKey,
        UserID,
        MemberType,
    ]);

    useEffect(() => {
        if (!DefaultFYear) {
            return;
        }
        const fy = parseInt(String(DefaultFYear).trim(), 10);
        if (Number.isNaN(fy)) {
            return;
        }
        const fyStart = moment(`${fy}-04-01`);
        const fyEnd = moment(`${fy + 1}-03-31`);
        const today = moment();
        const defaultEnd = today.isBetween(fyStart, fyEnd, "day", "[]") ? today : fyEnd;
        const end = defaultEnd.format(config.date_format_input);
        setEndDate(end);
        setAppliedEndDate(end);
        setPageNo(1);
        setSearchTrigger((prev) => prev + 1);
    }, [DefaultFYear]);

    const printUrl = `/Accounts/PrintTrialBalanceHeadWise?FYear=${encodeURIComponent(
        DefaultFYear || ""
    )}&EndDate=${encodeURIComponent(appliedEndDate)}&AccountLevel=${appliedAccountLevel || 0}&ShowZeroAccounts=${appliedShowZeroAccounts ? "1" : "0"}&ShowThirdOnly=${appliedShowThirdOnly ? "1" : "0"}`;

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            return listOfLedger.map((item, index) => (
                <tr key={index}>
                    <td>{index + 1 + pageSize * (pageNo - 1)}</td>
                    <td>
                        <NavLink to={`/Accounts/GeneralLedger/${item.Selected_Account.Account_code}?FYear=${DefaultFYear || ""}`}>
                            {item.Selected_Account.Account_code}
                        </NavLink>
                    </td>
                    <td>{item.Selected_Account.Account_desc}</td>
                    <td className="text-end">{item.ClosingDebit}</td>
                    <td className="text-end">{item.ClosingCredit}</td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan="5">
                    <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
                        No Data Found
                    </h4>
                </td>
            </tr>
        );
    };

    return (
        <>
            <AccountsMenu />
            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Trial Balance Head Wise</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Trial Balance Head Wise</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="card">
                            <div className="card-body p-md-4">
                                <div className="row gy-3 align-items-center">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Financial year</label>
                                            <select
                                                className="form-select"
                                                value={DefaultFYear || ""}
                                                onChange={(e) => setDefaultFYear(e.target.value)}
                                            >
                                                <option value="">Select year</option>
                                                <YearsDropDown selected={DefaultFYear} />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Select Level:</label>
                                            <select
                                                className="form-select"
                                                value={AccountLevel}
                                                onChange={(e) => setAccountLevel(e.target.value)}
                                            >
                                                <option value="0">All Levels</option>
                                                <option value="1">1st Level</option>
                                                <option value="2">2nd Level</option>
                                                <option value="3">3rd Level</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>As On:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={EndDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-check mt-md-4">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="flexCheckZeroAccounts"
                                                checked={showZeroAccounts}
                                                onChange={(e) => setShowZeroAccounts(e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckZeroAccounts">
                                                Show Zero Accounts
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-check mt-md-4">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="flexCheckThirdOnly"
                                                checked={showThirdOnly}
                                                onChange={(e) => setShowThirdOnly(e.target.checked)}
                                                disabled={AccountLevel !== "0"}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckThirdOnly">
                                                Show 3rd Level Only
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex gap-2 mt-md-4">
                                            <input
                                                type="button"
                                                value="Search"
                                                className="button button-primary flex-grow-1"
                                                onClick={runSearch}
                                            />
                                            <NavLink
                                                target="_blank"
                                                className="button button-primary flex-grow-1 text-center"
                                                to={printUrl}
                                            >
                                                Print
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-2">
                            <div className="card-body">
                                <table className="table table-theme table-hover">
                                    <tbody>
                                        <tr>
                                            <th colSpan={3}>
                                                {totalRecords} record{totalRecords === 1 ? "" : "s"}
                                            </th>
                                            <th colSpan={2} className="text-end text-muted fw-normal">
                                                Footer totals match selected filters
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Account Code</th>
                                            <th>Account Name</th>
                                            <th colSpan="2" className="text-center">Closing</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th className="text-end">Debit</th>
                                            <th className="text-end">Credit</th>
                                        </tr>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan="5">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                        ) : (
                                            renderLedger()
                                        )}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td className="text-end fw-bold">Grand Total</td>
                                            <td className="text-end fw-bold">{ClosingDebitTotal}</td>
                                            <td className="text-end fw-bold">{ClosingCreditTotal}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                {totalRecords > pageSize && (
                                    <div className="pagination-wrap mt-3">
                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                    <select
                                                        className="form-select"
                                                        style={{ width: "100px" }}
                                                        value={pageSize}
                                                        onChange={(e) => {
                                                            setPageNo(1);
                                                            setPageSize(parseInt(e.target.value, 10));
                                                        }}
                                                    >
                                                        <option value="10">10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="200">200</option>
                                                        <option value="500">500</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TrialBalanceHeadWise;
